/* eslint-disable no-unused-vars */
import $ from "jquery";

const contentReceptenArchive = () => {
  // used element
  const el = {
    pagination: ".pagination-item a",
    search: "#search-recepten",
    searchIcon: ".js-search-recepten-icon",
    pageName: "input[name='page_name']",
    toggleFilterBtn: "button.js-toggle-filter",
    textToggleFilterBtn: ".btn-text-filter",
  };
  let checkbox = ".custom-filter";

  /**
   * run all functions
   */
  const init = () => {
    if ($(el.pageName).val() != "recipe") return;

    searchAjax();
    searchAjaxWithIcon();
    filterAjax();
    paginationAjax();
    openCloseFilterMobile();
  };

  const searchAjax = () => {
    $(document).on("keyup", el.search, function (e) {
      if (e.keyCode === 13) {
        const $thisEl = $(e.target);
        const filters = collectInput();

        updateCurrentUrl(filters, 1, $thisEl.val());
        requestData(filters, 1, $thisEl.val());
      }
    });
  };

  const searchAjaxWithIcon = () => {
    $(document).on("click", el.searchIcon, function (e) {
      const $thisEl = $(e.target);
      const filters = collectInput();

      updateCurrentUrl(filters, 1, $(el.search).val());
      requestData(filters, 1, $(el.search).val());
    });
  };

  /**
   * doing ajax when pagination item clicked and rerender the result
   */
  const paginationAjax = () => {
    $(document).on("click", el.pagination, function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const $thisEl = $(e.target);
      const paginationUrl = $thisEl.attr("href");

      const pagedValue = extractPageNumber(paginationUrl);
      const searchValue = getSearchValue();

      const filters = collectInput();
      updateCurrentUrl(filters, pagedValue, searchValue);
      requestData(filters, pagedValue, searchValue);
    });
  };

  const extractPageNumber = (url) => {
    // Extract the path from the URL
    const path = new URL(url).pathname;

    // Use a regular expression to match the page number in the path
    const match = path.match(/\/page\/(\d+)\/?$/);

    if (match) {
      // Return the matched page number
      return parseInt(match[1]);
    }

    // Default to 1 if page number is not found
    return 1;
  };
  /**
   * doing ajax when filter was checked
   */
  const filterAjax = () => {
    $(document).on("click", checkbox, function (e) {
      // eslint-disable-line no-unused-vars

      const filters = collectInput();
      const searchValue = getSearchValue();

      updateCurrentUrl(filters, 1, searchValue);
      requestData(filters, 1, searchValue);
    });
  };

  const updateCurrentUrl = (filters, page = 1, search = false) => {
    // Get the current URL
    const url = new URL(window.location.href);

    if (search) {
      url.searchParams.set("search", search);
    } else {
      url.searchParams.delete("search");
    }

    console.log(containPageNumber(url.toString())); // eslint-disable-line no-console

    if (containPageNumber(url.toString())) {
      url.pathname = changePageNumber(url.pathname, page);
    } else {
      url.pathname += "page/" + page;
    }

    if (filters.length > 0) {
      // append filters query param
      url.searchParams.set("filters", filters.join(","));
    } else {
      // if no filter selected remove filters query param
      url.searchParams.delete("filters");
    }

    // Replace the current state in the browser history
    window.history.replaceState({}, document.title, url.toString());
  };

  /**
   * collect input from user
   */
  const collectInput = () => {
    // $(document).on("click", checkbox, function (e) {
    // eslint-disable-line no-unused-vars
    let INPUT_USER = [];
    $(checkbox).each(function () {
      if ($(this).is(":checked")) {
        INPUT_USER.push($(this).val());
      }
    });

    return INPUT_USER;
  };

  const getSearchValue = () => {
    return $(el.search).val();
  };

  const containPageNumber = (url) => {
    const pattern = /\/page\/\d+\/?/;
    return pattern.test(url);
  };

  const changePageNumber = (pathName, newPageNumber = 1) => {
    const pattern = /\/page\/(\d+)\/?/;
    const updatedUrl = pathName.replace(
      pattern,
      "/page/" + newPageNumber + "/"
    );

    return updatedUrl;
  };

  /**
   * request data to ajax
   * @param {array} input
   */
  const requestData = (input, paged = 1, search = false) => {
    // run loading animations
    $(".wrapper-card-recepten").addClass("loading");

    let data = {
      // eslint-disable-next-line no-undef
      nonce: themeObj.ajax.nonce,
      input: input,
      // eslint-disable-next-line no-undef
      action: themeObj.ajax.recepten.action,
      paged: paged,
    };

    if (search) {
      data.search = search;
    }

    $.ajax({
      url: themeObj.ajaxUrl, // eslint-disable-line no-undef
      type: "POST",
      dataType: "json",
      data: data,
    })
      .done(function (r) {
        $(".wrapper-card-recepten").empty();
        $(".wrapper-card-recepten").append(r.data);
      })
      .always(function () {
        // stop loading animations
        $(".wrapper-card-recepten").removeClass("loading");
      });
  };

  /**
   *  open close filter for mobile
   */
  const openCloseFilterMobile = () => {
    $(el.toggleFilterBtn).hide();

    if (window.screen.width < 600) {
      $(el.toggleFilterBtn).show();
      $("#filter-holder").hide();
      $(document).on("click", el.toggleFilterBtn, function () {
        const textArr = $(el.textToggleFilterBtn).data("text");
        const currentText = $(this).find(el.textToggleFilterBtn).text().trim();
        const newText = currentText === textArr[0] ? textArr[1] : textArr[0];

        // toggle text
        $(this).find(el.textToggleFilterBtn).text(newText);

        // toggle element
        $("#filter-holder").slideToggle();
      });
    }
  };

  init();
};

try {
  contentReceptenArchive();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error(error);
}
